exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".speech--guest {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  margin-top: 130px; }\n  .speech--guest .speech--title {\n    background: url(" + require("../../../images/topic-title.png") + ") no-repeat center;\n    width: 226px;\n    height: 80px;\n    font-size: 30px;\n    text-align: center;\n    line-height: 80px;\n    margin-bottom: 40px; }\n  .speech--guest .speech--body,\n  .speech--guest .speech--more {\n    width: 1035px;\n    display: flex;\n    flex-wrap: wrap; }\n  .speech--guest .btn--more {\n    width: 140px;\n    height: 37px;\n    border: 1px solid #2b67ff;\n    border-radius: 19.5px;\n    line-height: 37px;\n    text-align: center;\n    font-size: 12px;\n    cursor: pointer;\n    user-select: none; }\n    .speech--guest .btn--more > span {\n      margin-right: 7px; }\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/sass-loader/lib/loader.js!./src/pages/home/presidium/index.scss
// module id = 641
// module chunks = 0